var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import FlyoutUncontrolled from "./FlyoutUncontrolled.js";
import FlyoutControlled from "./FlyoutControlled.js";
import FlyoutTrigger from "./FlyoutTrigger.js";
import FlyoutContent from "./FlyoutContent.js";
import FlyoutArrow from "./FlyoutArrow.js";
var FlyoutBase = function (props, ref) {
    var active = props.active;
    if (typeof active === "boolean")
        return (React.createElement(FlyoutControlled, __assign({}, props, { ref: ref })));
    return (React.createElement(FlyoutUncontrolled, __assign({}, props, { ref: ref })));
};
var Flyout = React.forwardRef(FlyoutBase);
Flyout.Trigger = FlyoutTrigger;
Flyout.Content = FlyoutContent;
Flyout.Arrow = FlyoutArrow;
export default Flyout;
